import { LoadingFile } from '@components/SiteUserUpload/Components/Steps/components/LoadingFile';
import React from 'react';
import { useSiteUploadSlice } from '@restore/siteUpload/siteUpload.slice';
import { VerificationStepsItem } from 'src/store-redux/siteUpload/siteUploadStore.types';
import { CheckStatus } from '@components/SiteUserUpload/types/uploadTypes';

type FilePolingSuccessProps = {
  progress: number;
  handleClick: () => void;
};

export const FilePolingSuccess = ({ handleClick }: FilePolingSuccessProps) => {
  return (
    <LoadingFile
      text={'All checks passed'}
      subTitle={
        'You can confirm the upload, or\nview validation details first.'
      }
      spinnerType={'Semicircle'}
      spinnerFill='bg-yellowGreen'
      semicircleColor='text-yellowGreen'
      tryAgainButton
      tryAgainText='View details'
      tryAgainFunc={handleClick}
    />
  );
};

type FilePolingWarningProps = {
  warningCount?: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  currentStep: number;
};

export const FilePolingWarning = ({
  warningCount,
  setCurrentStep,
  currentStep,
}: FilePolingWarningProps) => {
  const handleClick = () => {
    setCurrentStep(currentStep + 1);
  };
  return (
    <LoadingFile
      text={'We have encountered a few data inconsistency warnings'}
      subTitle={
        'Please provide additional information to avoid \nqueries during QC process.'
      }
      warningCount={warningCount}
      spinnerType={'Semicircle'}
      tryAgainButton
      tryAgainText='Resolve'
      tryAgainFunc={handleClick}
    />
  );
};

type FileDicomErrorProps = {
  handleReupload: () => void;
  verificationSteps?: VerificationStepsItem[];
};

export const FileDicomError = ({
  handleReupload,
  verificationSteps,
}: FileDicomErrorProps) => {
  const [fileType] = useSiteUploadSlice((state, actions) => [
    state.fileType,
    actions.setFileType,
  ]);

  const fileTypeError = !!verificationSteps?.find(
    step =>
      step.status === CheckStatus.WARNING &&
      step.type === 'DXA_DEVICE_NON_MATCH'
  );

  return (
    <LoadingFile
      text={`${fileType} file format check failed`}
      subTitle={
        fileTypeError
          ? 'The file origin is different to one(s) previously uploaded, please ensure you are uploading the correct file of the same type as before.'
          : `File processing failed. ${fileType} files were corrupted. \nPlease try again later or contact support for assistance.`
      }
      spinnerType={'Semicircle'}
      tryAgainButton
      tryAgainText='Reupload'
      tryAgainFunc={handleReupload}
    />
  );
};

type FilePolingErrorProps = {
  handleTryAgain: () => void;
};

export const FilePolingError = ({ handleTryAgain }: FilePolingErrorProps) => {
  return (
    <LoadingFile
      text={'File Processing Failed'}
      subTitle={
        'File processing failed. The file you was uploading was not saved.\nPlease try again later or contact support for assistance.'
      }
      spinnerType={'Semicircle'}
      tryAgainButton
      tryAgainFunc={handleTryAgain}
      currentSubStep={2}
    />
  );
};
